const BUTTON_BASE =
  "inline-flex min-h-11 items-center md:min-h-9 [@media(pointer:coarse)]:min-h-11 rounded-lg px-4 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60";

/** The one main button of a card or panel (Save, Add). */
export const PRIMARY_BUTTON = `${BUTTON_BASE} border border-indigo-600 bg-indigo-600 text-white hover:bg-indigo-700`;
/** Every other button (Cancel, Import, Back). */
export const SECONDARY_BUTTON = `${BUTTON_BASE} border border-gray-300 bg-white text-gray-900 hover:bg-gray-50`;
